import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';
import { gmiRequest } from 'actions/request';

/**
 * getLoyaltyTerms
 * gmi content call to fetch terms and conditions for alamo insiders
 *
 * @returns {Promise}
 */
export const getLoyaltyTerms = () => (dispatch) =>
  dispatch(
    actions.request({
      service: services.gma.content.termsLoyalty,
    })
  );

/**
 * getSupportContactInfo
 * gmi service call fetch support contact data from GBO
 *
 * @param {string} country - the country code for support data is being fetched
 * @return {Promise}
 */
export const getSupportContactInfo = (country) => (dispatch) =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: {
          endpoint: {
            country,
          },
        },
        service: services.gma.content.supportContact,
      }),
    })
  );
